import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const EmbeddedAdminContractPerformanceReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/contract-performance-report', component: FuseLoadable({ loader: () => import('./ViewEmbeddedContractPerformanceReportApp') }) }],
};

export default EmbeddedAdminContractPerformanceReportConfig;
